import { APP_CONSTANT } from 'model/constants/actionConstants';

const initState = {
	visibleMenuDrawer: false,
};

export default (state = initState, action) => {
	switch (action.type) {
		case APP_CONSTANT.SET_SHOW_DRAWER_MENU:
			return { ...state, visibleMenuDrawer: action.payload };

		default:
			return state;
	}
};
